var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-rogue-wrapper',{attrs:{"name":"profileChangePassword","type":"simple","title":_vm.$t('dashboard.change_password.title'),"raised":""}})}
var staticRenderFns = []

export { render, staticRenderFns }